

/// <reference path="IntegratorMapping.ts" />

// Generated class IntegratorMappingKey_ManagedObject

class IntegratorMappingKey_ManagedObject extends IntegratorMapping
{

    // Property: sourceKey
    set sourceKey(value:string) {
        this.setValueForKey(value, 'sourceKey');
    }
    get sourceKey():string {
        return this.valueForKey('sourceKey');
    }
    set sourceKeyPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'sourceKey');
    }
    get sourceKeyPrimitiveValue():string {
        return this.primitiveValueForKey('sourceKey');
    }

    // Property: targetKey
    set targetKey(value:string) {
        this.setValueForKey(value, 'targetKey');
    }
    get targetKey():string {
        return this.valueForKey('targetKey');
    }
    set targetKeyPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'targetKey');
    }
    get targetKeyPrimitiveValue():string {
        return this.primitiveValueForKey('targetKey');
    }
    // Relationship: mappingInfo
    set mappingInfo(value:IntegratorMappingInfo) {
        this.setValueForKey(value, 'mappingInfo');
    }
    get mappingInfo():IntegratorMappingInfo {
        return this.valueForKey('mappingInfo') as IntegratorMappingInfo;
    }
}
